import { Link } from 'react-router-dom'

import {
  ADMIN_TREE,
  PUBLIC_TREE,
  type ScreenNode,
} from '@/public/features/site/constants/sitemap'

function countScreens(nodes: ScreenNode[]): number {
  return nodes.reduce((sum, n) => sum + 1 + (n.children ? countScreens(n.children) : 0), 0)
}

function ScreenItem(props: { node: ScreenNode; linkable: boolean }) {
  const { node, linkable } = props
  // 파라미터가 있거나 관리자 미로그인이면 링크로 만들지 않는다 — 눌러도 못 가는 링크를 두지 않는다.
  const isLink = linkable && node.via === undefined && !node.pending

  return (
    <li className="border-t border-white-300 py-3 [&+&]:mt-0.5">
      <div className="flex flex-wrap items-center gap-2.5">
        {isLink ? (
          <Link className="text-[15px] font-semibold text-black-800" to={node.path}>
            {node.label}
          </Link>
        ) : (
          <span className="text-[15px] font-medium text-white-900">{node.label}</span>
        )}
        <code className="rounded-[5px] bg-white-200 px-[7px] py-0.5 font-mono text-caption text-black-100">{node.path}</code>
        {node.pending === true && <span className="inline-block rounded-full border border-white-400 px-2 py-0.5 text-[11px] font-semibold bg-white-200 text-black-500">준비 중</span>}
      </div>
      <p className="mt-[5px] mb-0 text-label text-black-100">{node.desc}</p>
      {node.via !== undefined && <p className="mt-1 mb-0 text-caption text-white-900">진입 경로 — {node.via}</p>}
      {node.children !== undefined && (
        <ul className="mt-2.5 mb-0 list-none border-l-2 border-white-300 py-0 pr-0 pl-4 [&>li]:border-t-0 [&>li]:pt-2.5 [&>li]:pb-0">
          {node.children.map((c) => (
            <ScreenItem key={c.path} node={c} linkable={linkable} />
          ))}
        </ul>
      )}
    </li>
  )
}

export function SitemapPage() {
  const publicCount = countScreens(PUBLIC_TREE)
  const adminCount = countScreens(ADMIN_TREE)

  return (
    <div className="rounded-[10px] border border-white-300 bg-white-50 p-7">
      <h1 className="m-0 mb-1.5 text-headline-sm font-bold tracking-[-0.02em]">사이트맵</h1>
      <p className="m-0 mb-7 text-body-sm text-black-100">
        해봄에 있는 화면 전체입니다. 공개 {publicCount}개 · 관리자 {adminCount}개, 모두{' '}
        {publicCount + adminCount}개입니다. 메뉴에 없는 화면(등록·수정 폼처럼 목록을 거쳐야 닿는
        것)도 여기에 다 적었습니다.
      </p>

      <section className="[&:first-of-type>h2]:mt-2">
        <h2 className="mt-10 mb-3.5 text-body-md font-bold">공개 화면 ({publicCount})</h2>
        <p className="text-black-100 text-label">로그인 없이 누구나 볼 수 있습니다.</p>
        <ul className="mt-3.5 mb-0 list-none p-0">
          {PUBLIC_TREE.map((n) => (
            <ScreenItem key={n.path} node={n} linkable />
          ))}
        </ul>
      </section>

      <section className="[&:first-of-type>h2]:mt-2">
        <h2 className="mt-10 mb-3.5 text-body-md font-bold">관리자 화면 ({adminCount})</h2>
        <div className="rounded-lg bg-white-200 px-4 py-3.5 text-label text-black-500">
          관리자 화면은 <b>관리자 앱</b>에 있습니다 — 이 사이트에는 없어 링크를 걸지 않았습니다.
          <br />
          <span className="text-black-100 text-label">
            화면을 감추는 것은 보안 장치가 아닙니다 — 실제 차단은 서버가 합니다.
          </span>
        </div>
        <ul className="mt-3.5 mb-0 list-none p-0">
          {ADMIN_TREE.map((n) => (
            <ScreenItem key={n.path} node={n} linkable={false} />
          ))}
        </ul>
      </section>
    </div>
  )
}
